// AdminPage

export default function AdminPage() {
  return (
    <main className="min-h-screen bg-twilight-indigo-950 px-6 py-16 text-white">
      <h1 className="font-display text-4xl font-bold">Admin Page</h1>
      <p className="mt-4 text-slate-300">
        Admin dashboard will be built later.
      </p>
    </main>
  );
}